import LoaderSvg from '../CircularLoader/LoaderSvg'
import { CustomButton, FilledButton, FilledButtonBlue, OutlinedButton } from './index.style'

/**
 * @param {object} props
 * @param {string} props.id
 * @param {string} props.width
 * @param {'custom'|'filled'|'outlined'} props.variant
 * @param {string} props.color
 * @param {string} props.backgroundColor
 * @param {string} props.border
 * @param {string} props.borderRadius
 * @param {boolean} props.disabled
 * @param {() => void} props.handleClick
 * @param {React.ReactNode} props.children
 * @returns {React.FC}
 */
function Button(props) {
  const {
    id,
    width,
    variant = 'custom',
    color,
    backgroundColor,
    border,
    borderRadius,
    disabled,
    loading,
    handleClick: propsHandleClick,
    children,
    ...rest
  } = props

  const handleClick = () => {
    if (loading || disabled) return
    if (propsHandleClick) propsHandleClick()
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleClick()
  }

  switch (variant) {
    case 'filled':
      return (
        <FilledButton
          id={id}
          tabIndex={0}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          loading={loading}
          width={width}
          {...rest}
        >
          {loading ? <LoaderSvg isLoader size="36px" /> : children}
        </FilledButton>
      )
    case 'filled-blue':
      return (
        <FilledButtonBlue
          id={id}
          tabIndex={0}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          loading={loading}
          width={width}
          backgroundColor={backgroundColor}
          color={color}
          {...rest}
        >
          {loading ? <LoaderSvg isLoader size="36px" /> : children}
        </FilledButtonBlue>
      )
    case 'outlined':
      return (
        <OutlinedButton
          id={id}
          tabIndex={0}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          loading={loading}
          width={width}
          {...rest}
        >
          {loading ? <LoaderSvg isLoader size="36px" /> : children}
        </OutlinedButton>
      )
    case 'custom':
    default:
      return (
        <CustomButton
          id={id}
          tabIndex={0}
          textColor={color}
          backgroundColor={backgroundColor}
          border={border}
          borderRadius={borderRadius}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          loading={loading}
          width={width}
          variant={variant}
          {...rest}
        >
          {children}
        </CustomButton>
      )
  }
}

export default Button
